/* LAYOUT */
export const CHANGE_SIDEBAR_TYPE = 'CHANGE_SIDEBAR_TYPE';
